import { render, staticRenderFns } from "./ListAdministratorPage.vue?vue&type=template&id=71ec1ed9"
import script from "./ListAdministratorPage.vue?vue&type=script&lang=js"
export * from "./ListAdministratorPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports